export const commonBaseInputStyles = (theme: any) => ({
  backgroundColor: theme.palette.isDarkMode
    ? theme.palette.neutral[150]
    : theme.palette.common.white,
  color: theme.palette.isDarkMode ? theme.palette.neutral[500] : 'inherit',
  borderColor: theme.palette.isDarkMode
    ? theme.palette.neutral[250]
    : theme.palette.neutral[300],
  svg: {
    fill: theme.palette.isDarkMode ? theme.palette.neutral[500] : 'inherit',
  },
  '&:hover': {
    backgroundColor: theme.palette.isDarkMode
      ? theme.palette.neutral[300]
      : undefined,
  },
  boxShadow: theme.palette.isDarkMode ? 'none' : '{CSS box-shadow}',
  '&.MuiInput-colorDanger': {
    borderColor: theme.palette.danger[300],
  },
  '&.Mui-disabled': {
    color: theme.palette.isDarkMode
      ? theme.palette.neutral[400]
      : theme.palette.neutral[500],
    borderColor: theme.palette.isDarkMode
      ? theme.palette.neutral[250]
      : theme.palette.neutral[300],
    svg: {
      fill: theme.palette.isDarkMode
        ? theme.palette.neutral[400]
        : theme.palette.neutral[500],
    },
  },
  '&.MuiInput-root.Mui-focused': {
    borderColor: theme.palette.isDarkMode
      ? theme.palette.primary[200]
      : theme.palette.primary[500],
    boxShadow: 'none',
  },
});
